import classNames from 'classnames'
import React from 'react'
import { PortableTextBodyElement } from '../../utilities/blockContent'
import { isNullOrWhiteSpace } from '../../utilities/string'
import { Grid } from '../Grid'
import { Paragraph } from '../Paragraph'
import { RichTextArea } from '../PortableText/RichTextArea'

export interface FullWidthTextBlockProps {
  body?: PortableTextBodyElement[]
  id?: string
  preamble?: string
  title?: string
}

export const FullWidthTextBlock = ({
  body,
  id,
  preamble,
  title,
}: FullWidthTextBlockProps) => (
  <div
    className={classNames(
      'w-full flex flex-col gap-30 overflow-hidden py-60',
      'blockmargin next-sibling-[blockmargin]:pt-0 last:pb-0 sm:py-90 sm:next-sibling-[blockmargin]:pt-0 lg:py-120 lg:next-sibling-[blockmargin]:pt-0'
    )}
  >
    <Grid>
      <div
        className={classNames(
          'flex flex-col gap-30 overflow-hidden',
          'col-span-full',
          'sm:col-start-2 sm:col-span-4',
          'md:col-start-1 md:col-span-full',
          'lg:col-start-2 lg:col-span-6 lg:-mx-75',
          'xl:col-start-2 xl:col-span-8 xl:-mx-45',
          'xxl:col-start-4'
        )}
        id={id}
      >
        {!isNullOrWhiteSpace(title) && (
          <h3 className={classNames('font-h3 text-h3 text-secondary-darker')}>{title}</h3>
        )}

        {!isNullOrWhiteSpace(preamble) && (
          <Paragraph
            className={classNames('font-preamble text-preamble text-secondary-darker')}
          >
            {preamble}
          </Paragraph>
        )}

        {!!body && (
          <div>
            <RichTextArea value={body} />
          </div>
        )}
      </div>
    </Grid>
  </div>
)
